import { createSelector } from 'reselect';

const selectInvoicesState = (state) => state.invoicesReducer;
export const selectInvoices = (isArchive) =>
  createSelector(selectInvoicesState, (state) =>
    state.invoices.filter((invoice) => isArchive === invoice.archived)
  );
